<template>
  <div>
    <el-button class="goBack" @click="goBack">返回</el-button>
    <div class="setSome">
      <div class="title_1">
        <div class="iconShow"></div>
        <div class="titleText">道路详情</div>
      </div>
      <div class="sectionSetItem">
        <div class="itemText"><span style="color:#E96B5A">* </span>层名称</div>
        <div class="inputCon">
          <el-input
            placeholder="请输入层名称"
            v-model="roadName"
          ></el-input>
        </div>
      </div>
      <div class="sectionSetItem">
        <div class="itemText"><span style="color:#E96B5A"></span>道路名称</div>
        <div class="inputCon">
          <el-input
            placeholder="请输入道路名称"
            v-model="name"
            disabled
          ></el-input>
        </div>
      </div>
      <div class="sectionSetItem">
        <div class="itemText">当前划定面积</div>
        <div class="inputCon">
          <el-input placeholder="请输入面积" v-model="addObj.area" disabled></el-input>
        </div>
      </div>
      <div class="title_1">
        <div class="iconShow"></div>
        <div class="titleText">请选择输入方式</div>
        <div class="inputCon1">
          <el-select v-model="inputway" placeholder="请选择输入方式">
            <el-option
              v-for="item in inputWayList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
            </el-select>
        </div>
      </div>
      <div class="pointerList">
        <div class="listContain">
          <div style="paddingBottom: 8px" v-if="inputway == '手动输入'">
            请输入顶点坐标：
          </div>
          <div style="paddingBottom: 8px" v-if="inputway == '压路机采集'" class="roller">
            请选择压路机：
            <el-select class="selectroller" v-model="addObj.equipCode" @change="changeEquip" placeholder="选择压路机">
                <el-option
                  v-for="item in equipList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
          </div>
          <div class="tablelistBody1">
            <el-table
              :data="dataList"
              style="width: 100%"
              size="medium"
              v-loading="listLoading"
            >
              <el-table-column prop="name" label="顶点" width="60px">
                <template slot-scope="scope">
                  <span class="pointerName">{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="x" label="X轴" width="">
                <template slot-scope="scope">
                  <el-input
                    style="color: #282828"
                    placeholder=""
                    v-model="scope.row.x"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="y" label="Y轴" width="">
                <template slot-scope="scope">
                  <el-input
                    style="color: #282828"
                    placeholder=""
                    v-model="scope.row.y"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="tableBut" v-if="inputway == '手动输入'">
            <el-button
              type="danger"
              danger
              style="width: 105px"
              @click="addPointer(dataList.length)"
              >增加一个顶点</el-button
            >
            <el-button
              type="warning"
              danger
              style="width: 105px"
              @click="delPointer(dataList.length)"
              >删除一个顶点</el-button
            >
            <el-button type="info" plain @click="resetPoint"
              >全部重置</el-button
            >
          </div>
          <div class="tableBut" v-if="inputway == '压路机采集'">
            <el-button
              type="danger"
              danger
              style="width: 105px"
              @click="pickPointer(dataList.length)"
              >采集当前点</el-button
            >
            <el-button
              type="warning"
              danger
              style="width: 105px"
              @click="delPointer(dataList.length)"
              >删除上一点</el-button
            >
            <el-button type="info" plain @click="resetPoint"
              >全部重置</el-button
            >
            <!-- <el-button
              type="danger"
              danger
              @click="assignment(1)"
              style="width: 305px; marginTop: 10px; marginLeft: 0px"
              >划定作业块</el-button
            > -->
          </div>
          <!-- <div style="paddingBottom: 8px;paddingTop: 8px">
            请输入作业方向坐标：
          </div>
          <div class="tablelistBody1">
            <el-table
              :data="directionPoint"
              style="width: 100%"
              size="medium"
              v-loading="listLoading"
            >
              <el-table-column prop="name" label="点位" width="65px">
                <template slot-scope="scope">
                  <span class="pointerName">{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="x" label="X轴" width="">
                <template slot-scope="scope">
                  <el-input
                    style="color: #282828"
                    placeholder=""
                    v-model="scope.row.x"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="y" label="Y轴" width="">
                <template slot-scope="scope">
                  <el-input
                    style="color: #282828"
                    placeholder=""
                    v-model="scope.row.y"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div> -->
          <el-button
              type="danger"
              danger
              @click="assignment(1)"
              style="width: 305px; marginTop: 10px; marginLeft: 0px"
              >划定道路</el-button
            >
        </div>
      </div>
      <!-- <div class="title_1">
        <div class="iconShow"></div>
        <div class="titleText">设置障碍区域</div>
        <div class="inputCon1">
          <el-select v-model="addObj.barType" placeholder="请选择障碍类型">
            <el-option
              v-for="item in barList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="pointerList" v-if="addObj.barType=='矩形'">
        <div class="listContain">
          <div class="tablelistBody1">
            <el-table
              :data="bardataList"
              style="width: 100%"
              size="medium"
            >
              <el-table-column prop="name" label="顶点" width="60px">
                <template slot-scope="scope">
                  <span class="pointerName">{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="x" label="X轴" width="">
                <template slot-scope="scope">
                  <el-input
                    style="color: #282828"
                    placeholder=""
                    v-model="scope.row.x"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="y" label="Y轴" width="">
                <template slot-scope="scope">
                  <el-input
                    style="color: #282828"
                    placeholder=""
                    v-model="scope.row.y"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="tableBut">
            <el-button
              type="danger"
              danger
              style="width: 105px"
              @click="addBarPoint"
              >添加</el-button
            >
            <el-button type="info" plain @click="resetBarPoint"
              >全部重置</el-button
            >
            <el-button
              type="danger"
              danger
              @click="assignment(1)"
              style="width: 305px; marginTop: 10px; marginLeft: 0px"
              >划定障碍区</el-button
            >
          </div>
          <div class="barCon">
            <div class="barContain" v-for="(item,index) in barListCont" :key="index">
              <div class="barname">障碍{{numTofont(index)}}</div>
              <div class="barrecord">
                <div v-for="(i,index) in item.points" :key="index">{{i.name+" ("+i.x+","+i.y+") "}}</div>  
              </div>
              <div class="barclose el-icon-close" @click="removeBarCont(index)"></div>
            </div>
          </div>
        </div>
      </div> -->
      <div
        class="sectionBtn saveDiv"
        @click="saveFun"
      >
        保存
      </div>
    </div>
    <div class="canvasCon">
      <div class="canvas-container3">
        <canvas id="myCanvasunroadset1" width="1490" height="810"></canvas>
        <canvas id="midCanvas1" width="1490" height="810"></canvas>
        <canvas id="dhCanvasunroadset2" width="1490" height="810"></canvas>
      </div>
    </div>
    <!-- <img :src="zhizhen" alt="" id="img"> -->
  </div>
</template>

<script>
import { fabric } from "fabric";
import {
  addRoad,
  editRoad,
  getRoadInfoDetails,
  getRoadInfo,
  // getEquipListOnline
} from "../../utils/api";
import mixinList from "../../utils/mixinList";
import websockMix from "../../utils/websockMix"
import { sendWSPush } from '../../utils/websocket'
import { calculateArea } from '../../utils/commons'
export default {
  name: "app",
  mixins: [mixinList,websockMix],
  data() {
    return {
      addObj: {
        area:'',
      },
      inputway:"手动输入",
      getChangeObj: "",
      scaleCode: "",
      leftDistance: "",
      topDistance: "",
      canvas: "",
      carcanvas:"",
      pointNum: 1,
      dataList: [],
      carList:[],
      // directionPoint:[{x:60,y:100,name:"起点"},{x:120,y:100,name:"终点"}],
      bardataList: [{x:'',y:'',name:"S1"},{x:'',y:'',name:"S2"},{x:'',y:'',name:"S3"},{x:'',y:'',name:"S4"}],
      barListCont:[
      ],
      setGray: 1,
      mileageValue: "",
      inputWayList: [
        // {
        //   label: "压路机采集",
        //   value: "压路机采集",
        // },
        {
          label: "手动输入",
          value: "手动输入",
        },
      ],
      barList: [
        // {
        //   label: "圆形",
        //   value: "圆形",
        // },
        {
          label: "矩形",
          value: "矩形",
        },
      ],
      arrowList: [
        {
          name: "工程中心",
          path: "/transfer/engineeringCenter",
        },
        {
          name: "道路管理",
          path: "/transfer/roadList",
        },
        {
          name: "道路详情",
          path: "/transfer/unroadInfo",
        },
        {
          name: "划定道路",
          path: "/transfer/unroadSet",
        },
      ],
      roadId: "",
      roadType: "",
      roadPointers: [],
      pileNumPointers: [],
      canvasBG: "#ffffff",
      inType: "",
      sectionId: "",
      resPositionInfo:"",
      carWidthMap: '',
      fabricClickId: '', //canvas 点击到的车辆id
      fabricClickName: '',
      parameterArr: ['icv','speed','temperature','oilmass','frequencyVal','swingVal'],
      parameterPavArr: ['speed','temperature','oilmass'],
      parameterRollSArr: ['icv','speed','temperature','oilmass','frequencyVal','swingVal'],
      parameterRollLArr: ['speed','temperature','oilmass'],
      setMask: 0,
      equipList:[],
      cengid:0,
      roadName:'',
      name:'',
      // zhizhen:require('../../images/all/jiantou.png')
    };
  },
  computed: {},
  created() {
    localStorage.removeItem('scaleCode')
  },
  mounted() {
    // createSocket('ws://172.16.16.105:9998/ws')
    this.$store.commit("setArrowList", this.arrowList);
    this.roadId = this.$route.query.id;
    this.cengid = this.$route.query.cengid || 0;
    this.roadType = this.$route.query.roadType;
    this.addObj.roadType = this.$route.query.roadType;
    this.inType = this.$route.query.type;
    this.canvas = new fabric.Canvas("midCanvas1", {
          // perPixelTargetFind: true,
    });
    this.carcanvas = new fabric.Canvas("dhCanvasunroadset2", {
      perPixelTargetFind: true,
    });
    this.canvas.selectable = false;
    this.initCanvas(this.carcanvas, this.canvas);
    let params = {
      id: this.roadId,
    };
    getRoadInfo({roadId: this.roadId,pageSize: 100}).then((res) => {
      this.name = res.data.content.info.name;
    })
    getRoadInfoDetails(params).then((res) => {
      this.roadType = res.data.content.info.roadType;
      if(this.inType == 'edit'){
        let dataMap={}
        res.data.content.info.list.map(item=>{
          if(item.id==this.cengid){
            this.dataList = item.vertexList;
            this.roadName=item.roadName
            this.barListCont = item.blockList;
            this.addObj=JSON.parse(JSON.stringify(item))
            dataMap=item
          }
        })
        console.log(dataMap, this.addObj,'dataMap')
        this.inputway = '手动输入';
        // this.addObj.barType=this.barListCont[0].blockType?"矩形":"圆形";
        let changeObj = this.changeUnRoadPointer(1490, 810,dataMap);
        this.getChangeObj = changeObj[0];
        this.setRoad(this.canvas,this.getChangeObj)
        this.$store.commit("setScaleCode", this.scaleCode);
        this.scaleCode = localStorage.getItem('scaleCode')
        this.setGrid();
        
      }else{
        let info={vertexList:[{x: -50, y: 0, name: "P0"},{x: 50, y: 0, name: "P1"},{x: 50, y: 100, name: "P2"},{x: -50, y: 100, name: "P3"}],blockList:[]}
        let changeObj = this.changeUnRoadPointer(1490, 810,info);
        this.getChangeObj = changeObj[0];
        this.setNewRoad(this.canvas,this.getChangeObj)
        this.$store.commit("setScaleCode", this.scaleCode);
        this.scaleCode = localStorage.getItem('scaleCode')
        this.setGrid();
      }
    });
    // getEquipListOnline().then(res=>{
    //     console.log(res,res.data.content.dataList,"在线设备。。。。。。。")
    //     let setMap = new Map()
    //     res.data.content.dataList.map((item)=>{
    //       this.equipList.push({label:item[1],value:item[0]})
    //       setMap.set(item[0],item[2])
    //     })
    //     this.carWidthMap = setMap
    //   })
  },
  methods: {
    changeEquip(){
      this.carList=[];
      let that=this;
      let setStr = '/GetEquipStatusData?equipCode='+this.addObj.equipCode //这里的id需要重定接口
      // let setStr ='/GetWorkStatus';
        sendWSPush(setStr,function(res){
          if(!res.content){
          console.log(res,"ressssssssssssssssss11")
            that.resPositionInfo=res;
            that.drawByWork(that.carcanvas,that.canvas,res)
          }
        })
    },
    goBack: function () {
      this.$router.go(-1);
    },
    numTofont(num){//数字转换成汉字
        let arr=["一","二","三","四","五","六","七","八","九","十"];
        if(num<=9){
            return arr[num]
        }else if((num+1)%10==0){
            return arr[(num+1)/10-1]+"十"
        }else if(10<=num<19){
            return "十"+arr[num-10]
        }else if(20<=num<=98){
            return arr[parseInt(num/10)]+"十"+arr[num%10]
        }
    },
    removeBarCont(index){ //删除障碍区域
        this.barListCont.splice(index,1);
        this.assignment(1)
    },
    assignment(num) {//划定作业块并进行绘制
      if(this.canvas){
        this.canvas.clear();
      }
      if(this.carcanvas){
        this.carcanvas.clear();
      }
      this.carList=[];
      this.setGrid();
      this.addObj.area=calculateArea(this.dataList)
      // this.initCanvas(this.carcanvas, this.canvas, this.getChangeObj);
      if(num==1){
        let dataMap={vertexList:this.dataList,blockList:this.barListCont}
        let changeObj = this.changeUnRoadPointer(1490, 810, dataMap);
        this.getChangeObj = changeObj[0];
        this.setRoad(this.canvas,this.getChangeObj)
      }else if(num==2){
        let getArr = JSON.parse(JSON.stringify(this.dataList));
        console.log(getArr,this.scaleCode,this.leftDistance,this.topDistance,"this.topDistance")
        getArr.map((item) => {
          item.x = item.x / this.scaleCode + (this.leftDistance*1);
          item.y = -item.y / this.scaleCode + (this.topDistance*1);
        });
        this.drawPickPoint(this.canvas, getArr);//2代表压路机采点的点位绘制
      }
      
      this.changeSetGray();
    },
    drawPickPoint(canvas, getArr){//绘制压路机采点的点位
    console.log("绘制道路点",getArr)
      for (let i = 0; i < getArr.length; i++) {
        canvas.add(
          new fabric.Text(getArr[i].name, {
            fontSize: 12,
            top: getArr[i].y + 5,
            left: getArr[i].x + 5,
            selectable: false,
            hasBorders: false,
            hasControls: false,
            fill: "black",
          })
        );
        
        canvas.add(
          new fabric.Circle({
            radius: 3,
            top: getArr[i].y - 3, //调整中心点的X轴坐标
            left: getArr[i].x - 3,
            selectable: false,
            hasBorders: false,
            hasControls: false,
            fill: "#000",
          })
        );
        console.log("绘制圆圈",getArr)
      }
    },
    addBarPoint() {//添加障碍区
      let data=JSON.parse(JSON.stringify(this.bardataList));
      this.barListCont.push({points:data,blockType: this.addObj.barType=='矩形'?0:1,radius:0});
    },
    resetBarPoint() {
      this.bardataList.map((item) => {
        item.x = '';
        item.y = '';
      });
    },
    resetPoint() {
      this.dataList.map((item) => {
        item.x = '';
        item.y = '';
      });
    },
    delPointer(num) {
      this.dataList.pop();
      this.pointNum = num - 1;
      this.assignment(2);
    },
    addPointer(num) {
      this.dataList.push({ x: '', y: '', name: (this.dataList[0]?this.dataList[0].name.charAt(0):"P") + num });
      this.pointNum = num + 1;
    },
    pickPointer(num) {//压路机采点
      this.dataList.push({ x: this.resPositionInfo.coordinateX, y: this.resPositionInfo.coordinateY, name: (this.dataList[0]?this.dataList[0].name.charAt(0):"W") + num });
      this.pointNum = num + 1;
      this.assignment(2);
    },
    initCanvas: function (canvas, midCanvas) {
      var that = this
      canvas.selections = false
      // this.setGrid(canvas,"#ffffff")
      
      //鼠标按下事件
      canvas.on("mouse:down", function (e) {
        if (e.target != null) {
        if ("id" in e.target) {
            that.fabricClickId = e.target.id;
            that.fabricClickName = e.target.carName;
            let topD = e.pointer.y - 80;
            let leftD = e.pointer.x;
            if (midCanvas != "") {
            that.$refs.setCarInfo.style.top = topD + "px";
            that.$refs.setCarInfo.style.left = leftD + "px";
            that.$refs.setCarInfo.style.display = "block";
            }
        }
        } else {
        if (midCanvas != "") {
            // that.$refs.setCarInfo.style.display = "none";  
        }
        }
        this.panning = true;
    });
    //鼠标抬起事件
    canvas.on("mouse:up", function () {
        this.panning = false;
    });
    // 移动画布事件
    canvas.on("mouse:move", function (e) {
        // //console.log(canvas.getObjects())
        if (this.panning && e && e.e) {
        var delta = new fabric.Point(e.e.movementX, e.e.movementY);
        canvas.relativePan(delta);
        if (midCanvas != "") {
            midCanvas.relativePan(delta);
        }
        }
      });
      var leftTo = canvas._offset.left;
      var topTo = canvas._offset.top;
      // 鼠标滚动画布放大缩小
      canvas.on("mouse:wheel", function () {
          //console.log(event)
          var zoom = (event.deltaY > 0 ? -0.1 : 0.1) + canvas.getZoom();
          zoom = Math.max(0.3, zoom); //最小为原来的1/10
          zoom = Math.min(10, zoom); //最大是原来的3倍
          that.$store.commit("setZoom", zoom);
          var zoomPoint = new fabric.Point(
          event.pageX - leftTo,
          event.pageY - topTo
          );
          canvas.zoomToPoint(zoomPoint, zoom);
          if (midCanvas != "") {
          midCanvas.zoomToPoint(zoomPoint, zoom);
          }
      });
    },
    setGrid() {
      let myCanvas = document.getElementById("myCanvasunroadset1");
      let ctx = myCanvas.getContext("2d");
      myCanvas.height=810;
      let gridSize = 50;
      let canvasWidth = ctx.canvas.width;
      let canvasHeight = ctx.canvas.height;
      let xLineTotal = Math.floor(canvasHeight / gridSize);
      let yLineTotal = Math.floor(canvasWidth / gridSize);
      ctx.fillStyle = "#E1E0E0";
      ctx.fillRect(0, 0, canvasWidth, canvasHeight);
      ctx.stroke();
      for (let i = 0; i <= xLineTotal; i++) {
        ctx.beginPath();
        ctx.moveTo(0, i * gridSize - 0.5);
        ctx.lineTo(canvasWidth, i * gridSize - 0.5);
        ctx.strokeStyle = "#D8D6D4";
        ctx.stroke();
      }
      for (let i = 0; i <= yLineTotal; i++) {
        ctx.beginPath();
        ctx.moveTo(i * gridSize - 0.5, 0);
        ctx.lineTo(i * gridSize - 0.5, canvasHeight);
        ctx.strokeStyle = "#D8D6D4";
        ctx.stroke();
      }
    },
    setRoad(canvas, setArr) {
      let leftArr = setArr[0];
      let barArr = setArr[2];
      let areaArr = leftArr;
      let areaPath = "M" + " " + areaArr[0][0] + " " + areaArr[0][1];
      for (let i = 1; i < areaArr.length; i++) {
        areaPath += " " + "L" + " " + areaArr[i][0] + " " + areaArr[i][1];
      }
      areaPath = areaPath + "z";
      canvas.add(
        new fabric.Path(areaPath, {
          strokeWidth: 2,
          stroke: "black",
          fill: "RGBA(132,132,198,0)",
          // strokeDashArray: [1,1],
          selectable: false,
          hasBorders: false,
          hasControls: false,
        })
      );
      for (let i = 0; i < barArr.length; i++) {
        let barPath = "";
        for (let j = 0; j < barArr[i].length; j++) {
          if (j == 0) {
            barPath = "M" + " " + barArr[i][0].x + " " + barArr[i][0].y;
          } else {
            barPath += " " + "L" + " " + barArr[i][j].x + " " + barArr[i][j].y;
          }
          canvas.add(
            new fabric.Text("S" + j, {
              fontSize: 12,
              top: barArr[i][j].y + 5,
              left: barArr[i][j].x + 5,
              selectable: false,
              hasBorders: false,
              hasControls: false,
              fill: "black",
            })
          );
          canvas.add(
            new fabric.Circle({
              radius: 3,
              top: barArr[i][j].y - 3, //调整中心点的X轴坐标
              left: barArr[i][j].x - 3,
              selectable: false,
              hasBorders: false,
              hasControls: false,
              fill: "#000",
            })
          );
        }
        barPath = barPath + "z";
        canvas.add(
          new fabric.Path(barPath, {
            strokeWidth: 1,
            stroke: "RGB(130,130,130)",
            fill: "RGBA(127,127,127,0.3)",
            // strokeDashArray: [1,1],
            selectable: false,
            hasBorders: false,
            hasControls: false,
          })
        );
      }
      for (let i = 0; i < setArr[1].length; i++) {
        canvas.add(
          new fabric.Text(
            setArr[1][i].name +
              "(" +
              setArr[1][i].x +
              "," +
              setArr[1][i].y +
              ")",
            {
              fontSize: 14,
              top: setArr[0][i][1] * 1.05 - 20,
              left: setArr[0][i][0] * 1.05 - 58,
              selectable: false,
              hasBorders: false,
              hasControls: false,
              fill: "black",
            }
          )
        );
      }
      // this.setGroupFun(canvas)
    },
    setNewRoad(canvas, setArr) {
      let leftArr = setArr[0];
      let areaArr = leftArr;
      let areaPath = "M" + " " + areaArr[0][0] + " " + areaArr[0][1];
      for (let i = 1; i < areaArr.length; i++) {
        areaPath += " " + "L" + " " + areaArr[i][0] + " " + areaArr[i][1];
      }
      areaPath = areaPath + "z";
      canvas.add(
        new fabric.Path(areaPath, {
          strokeWidth: 2,
          stroke: "RGBA(132,132,198,0)",
          fill: "RGBA(132,132,198,0)",
          // strokeDashArray: [1,1],
          selectable: false,
          hasBorders: false,
          hasControls: false,
        })
      );
      
      for (let i = 0; i < setArr[1].length; i++) {
        canvas.add(
          new fabric.Text(
            setArr[1][i].name +
              "(" +
              setArr[1][i].x +
              "," +
              setArr[1][i].y +
              ")",
            {
              fontSize: 14,
              top: setArr[0][i][1] * 1.05 - 20,
              left: setArr[0][i][0] * 1.05 - 58,
              selectable: false,
              hasBorders: false,
              hasControls: false,
              fill: "RGBA(132,132,198,0)",
            }
          )
        );
      }
      // this.setGroupFun(canvas)
    },
    changeUnRoadPointer(width, height, setObj) {
      let pileNumList = [];
      for (let i = 0; i < setObj.vertexList.length; i++) {
        pileNumList.push(setObj.vertexList[i]);
      }
      let visualWidth = 50;
      let visualHeight = 50;
      let widthArea = width - visualWidth;
      let heigthArea = height - visualHeight;
      let vertexList = this.arrToArr(setObj.vertexList);
      let blockList = this.arrToArr1(setObj.blockList);
      let xcordArr = this.arrToDArr(vertexList, 0);
      let ycordArr = this.arrToDArr(vertexList, 1);
      let xMaxCode = this.getMaxAMin(xcordArr, "max");
      let xMinCode = this.getMaxAMin(xcordArr, "min");
      let yMaxCode = this.getMaxAMin(ycordArr, "max");
      let yMinCode = this.getMaxAMin(ycordArr, "min");
      // 获取x与y轴道路数据最大差距
      let xGap =
        xMaxCode - xMinCode > 0 ? xMaxCode - xMinCode : -(xMaxCode - xMinCode);
      let yGap =
        yMaxCode - yMinCode > 0 ? yMaxCode - yMinCode : -(yMaxCode - yMinCode);
      // 获取x与y轴对于canvas高宽的比例
      let xScale = xGap / (widthArea - 50);
      let yScale = yGap / (heigthArea - 50);
      //设置页面canvas比列大小
      this.scaleCode = xScale > yScale ? xScale : yScale;
      localStorage.setItem('scaleCode',this.scaleCode)
      // 获取缩放后的道路和障碍区数据
      let midScaledLine = this.roadScale(vertexList, this.scaleCode);
      let barScaledLine = this.roadScale1(blockList, this.scaleCode);
      // 获取缩放后的道路数据中x与y轴最小值
      let scaledXMinCode = this.getMaxAMin(
        this.arrToDArr(midScaledLine, 0),
        "min"
      ).toFixed(2);
      let scaledXMaxCode = this.getMaxAMin(
        this.arrToDArr(midScaledLine, 0),
        "max"
      ).toFixed(2);
      let scaledYMinCode = this.getMaxAMin(
        this.arrToDArr(midScaledLine, 1),
        "min"
      ).toFixed(2);
      let scaledYMaxCode = this.getMaxAMin(
        this.arrToDArr(midScaledLine, 1),
        "max"
      ).toFixed(2);
      let addX = width / 2 - (scaledXMaxCode - scaledXMinCode) / 2;
      let addY = height / 2 - (scaledYMaxCode - scaledYMinCode) / 2;
      // 缩放后的道路数据中x与y轴最小值移动到左边与上边的差距值
      this.leftDistance = visualHeight / 2 - scaledXMinCode + addX - 23;
      this.topDistance = visualHeight / 2 - scaledYMinCode + addY - 15;
      localStorage.setItem('leftDistance',this.leftDistance);
      localStorage.setItem('topDistance',this.topDistance);
      // 转换缩放后的道路的数据
      let changedMid = this.changedRoad(
        midScaledLine,
        this.leftDistance,
        this.topDistance
      );
      let changedBar = this.changedRoad1(
        barScaledLine,
        this.leftDistance,
        this.topDistance
      );
      let returnObj = [changedMid, pileNumList, changedBar];
      return [returnObj, this.scaleCode];
    },
    arrToArr(arr) {
      //转换区块
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        setArr.push([arr[i].x, -arr[i].y]);
      }
      return setArr;
    },
    arrToArr1(arr) {
      //转换障碍
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        let setArr1 = [];
        for (let j = 0; j < arr[i].points.length; j++) {
          setArr1.push({ x: arr[i].points[j].x, y: -arr[i].points[j].y });
        }
        setArr.push(setArr1);
      }
      return setArr;
    },
    arrToDArr(arr, type) {
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        setArr.push(arr[i][type]);
      }
      return setArr;
    },
    getMaxAMin(arr, type) {
      if (type == "max") {
        return Math.max.apply(Math, arr);
      } else if (type == "min") {
        return Math.min.apply(Math, arr);
      }
    },
    roadScale(arr, code) {
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        setArr.push([arr[i][0] / code, arr[i][1] / code]);
      }
      return setArr;
    },
    roadScale1(arr, code) {
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        let setArr1 = [];
        for (let j = 0; j < arr[i].length; j++) {
          setArr1.push({ x: arr[i][j].x / code, y: arr[i][j].y / code });
        }
        setArr.push(setArr1);
      }
      return setArr;
    },
    changedRoad(arr, x, y) {
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        setArr.push([arr[i][0] + x, arr[i][1] + y]);
      }
      return setArr;
    },
    changedRoad1(arr, x, y) {
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        let setArr1 = [];
        for (let j = 0; j < arr[i].length; j++) {
          setArr1.push({ x: arr[i][j].x * 1 + x, y: arr[i][j].y * 1 + y });
        }
        setArr.push(setArr1);
      }
      return setArr;
    },
    changeSetGray: function () {
      this.setGray = 0;
    },
    saveFun: function () {
      if((this.roadName+'').trim()==''){
        this.$message({
          message:"层名称不能为空！",
          type:'warning'
        })
        return
      }
      if (this.inType == "edit") {
        this.addObj.id=this.cengid
        this.addObj.roadName=this.roadName;
        this.addObj.vertexList=this.dataList;
        this.addObj.blockList=this.barListCont;
        let params = this.addObj;
        editRoad(params).then((res) => {
          if(res.data.code==200){
            this.$message({
              message: "修改成功!",
              type: "success"
            });
            this.$router.push({ name: "UnRoadInfo",query:{id:this.roadId} });
          }
        });
      } else {
        this.addObj.roadInfoId=this.roadId;
        this.addObj.roadName=this.roadName;
        this.addObj.vertexList=this.dataList;
        this.addObj.blockList=this.barListCont;
        let params = this.addObj;
        addRoad(params).then((res) => {
          if(res.data.code==200){
            this.$message({
                message: "添加成功!",
                type: "success"
            });
            this.$router.push({ name: "UnRoadInfo",query:{id:this.roadId}});
          }
        });
      }
    },
  },
  components: {},
  destroyed(){
      // this.websock.close()
      // closeWs()
  },
};
</script>

<style lang="scss">
.canvas-container3{
  .canvas-container{
    position: fixed !important;
    top: 113px !important;
    left: 370px !important;
  }
}
#dhCanvasunroadset2 {
  position: absolute !important;
  top: 20px !important;
  left: 20px !important;
}
#myCanvasunroadset1 {
  position: absolute !important;
  top: 20px !important;
  left: 20px !important;
}
#midCanvas1 {
  position: absolute !important;
  top: 20px !important;
  left: 20px !important;
}
.goBack {
  position: fixed;
  right: 16px;
  top: 68px;
  z-index: 1000;
  height: 35px !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.pointerList {
  .el-input {
    height: 35px;
    width: 78px;
    input {
      height: 35px !important;
      width: 78px !important;
      border-radius: 0;
      padding: 0 10px !important;
    }
  }
}
.sectionSetItem {
  .inputCon {
    height: 25px;
    width: 208px;
    margin-right: 16px;
    float: right;
    line-height: 35px;
    font-size: 14px;
    color: #282828;
    .el-input {
      height: 35px;
      width: 208px;
      input {
        height: 35px !important;
        width: 208px !important;
        border-radius: 0;
      }
    }
    .mileage {
      height: 35px;
      width: 75px;

      input {
        height: 35px !important;
        width: 75px !important;
      }
    }
    .mileage_1 {
      margin: 0 9px;
    }
    .mileage_2 {
      margin-left: 10px;
    }
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.tablelistBody1{
  .el-table__body-wrapper{
    height: auto !important;
  }
}
.roller{
  .el-input input{
    border-radius: 5px !important;
    width: 120px !important;
  }
}
</style>
<style lang="scss">
.selectroller{
  .el-input__suffix{
    right: -30px !important;
  }
}
  
</style>
<style lang="scss" scoped="">
#img{
  display: none;
}
.pointerName {
  display: inline-block;
  color: #ffffff;
  font-size: 14px;
  padding: 7px;
  background: #e96b5a;
  line-height: 11px;
}
.setSome {
  width: 340px;
  min-height: 853px;
  background-color: #ffffff;
  margin-left: 15px;
  padding-top: 0px;
  padding-bottom: 80px;
  position: relative;
  float: left;
  .title_1 {
    height: 17px;
    width: 100%;
    position: relative;
    margin-bottom: 27px;
    margin-top: 20px;
    .inputCon1 {
      height: 25px;
      width: 148px;
      margin-right: 16px;
      line-height: 25px;
      font-size: 14px;
      color: #282828;
      position: absolute;
      top: 0;
      left: 150px;
    }
    .changePointer {
      width: 90px;
      height: 30px;
      background: rgba(254, 235, 232, 1);
      border: 1px solid rgba(233, 107, 90, 1);
      line-height: 28px;
      text-align: center;
      position: absolute;
      right: 16px;
      top: -6px;
      font-size: 12px;
      color: #e96b5a;
    }
    .iconShow {
      width: 4px;
      height: 16px;
      background: rgba(233, 107, 90, 1);
      position: absolute;
      top: 12px;
      left: 17px;
    }
    .titleText {
      height: 17px;
      line-height: 17px;
      font-size: 16px;
      font-weight: bold;
      color: #222222;
      position: absolute;
      top: 12px;
      left: 30px;
    }
  }
  .sectionSetItem {
    width: 100%;
    height: 35px;
    margin-top: 11px;
    // background-color: aqua;
    .itemText {
      height: 35px;
      line-height: 35px;
      width: auto;
      padding-left: 18px;
      color: #222222;
      font-size: 14px;
      float: left;
    }
  }
  .pointerList {
    width: 309px;
    height: auto;
    margin: 0 auto;
    margin-top: 36px;

    .tableBut {
      margin-top: 10px;
    }
    .barCon {
      margin-top: 10px;
      .barContain {
        display: flex;
        flex-direction: row;
        color: #ffffff;
        width: 305px;
        border: 1px solid #E96B5A;
        margin-bottom: 10px;
        .barname {
          width: 80px;
          background: rgba(233, 107, 90, 1);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .barrecord {
          display: flex;
          flex-wrap: wrap;
          width: 195px;
          justify-content:center;
          background-color: #fde3e1;
          color: #E96B5A;
          font-size: 12px;
          > div {
            margin-left: 5px;
          }
        }
        .barclose{
            display: flex;
            align-items: center;
            width: 35px;
            background: rgba(233, 107, 90, 1);
            font-size: 28px;
            justify-content: center;
            cursor: pointer;
        }
      }
    }
  }
  .sectionBtn {
    height: 45px;
    width: 310px;
    position: absolute;
    background: rgba(233, 107, 90, 1);
    color: #ffffff;
    line-height: 45px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    cursor: pointer;
  }
  .setGray {
    background: gray !important;
    pointer-events: none;
  }
  .saveDiv {
    right: 15px;
    bottom: 20px;
  }
}

.canvasCon {
  width: 1533px;
  height: 853px;
  background-color: #ffffff;
  margin-left: 15px;
  float: left;
  position: relative;
  position: fixed;
  top: 113px;
  left: 355px;
}
</style>